<p-tabs class="secondary-tabs" value="0">
  <p-tablist>
    <p-tab value="0">Nursing Orders</p-tab>
    <p-tab value="1">Provider Orders</p-tab>
    <p-tab value="2">Order Sets</p-tab>
    <p-tab value="3">History and Physical</p-tab>
    <p-tab value="4">Progress Notes</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      <app-nursing-orders-tab> </app-nursing-orders-tab>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-provider-orders-tab> </app-provider-orders-tab>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-order-sets-tab> </app-order-sets-tab>
    </p-tabpanel>
    <p-tabpanel value="3">
      <app-history-and-physical-tab> </app-history-and-physical-tab>
    </p-tabpanel>
    <p-tabpanel value="4">
      <app-progress-notes-tab> </app-progress-notes-tab>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>